<template>
    <v-container class="main-container responsive-height">
        <v-row>
            <!-- LEFT: FORM -->
            <v-col xl="5" lg="5" md="12" sm="12" cols="12">
                <v-card class="deposit-form create-account-form"
                    :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                    <v-card-text class="pb-0">
                        <h3 class="mb-3">{{ isEdit ? "Edit Nominee" : "Add Nominee" }}</h3>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Nominee Name</legend>
                                    <v-text-field v-model="form.nominee_name" label="Full Name" solo single-line
                                        hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Relationship</legend>
                                    <v-select v-model="form.relationship" :items="relationshipItems" item-text="text"
                                        item-value="value" solo single-line append-icon="mdi-chevron-down"
                                        label="Select Relationship" class="custom-select" hide-details="auto" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" v-if="form.relationship === 'others'">
                                <fieldset>
                                    <legend>Relationship (Others)</legend>
                                    <v-text-field v-model="form.relationship_other" label="Write relationship" solo
                                        single-line hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Allocation Percentage (%)</legend>
                                    <v-text-field v-model="form.allocation_percentage" label="%" type="number"
                                        min="0.01" max="100" step="0.01" solo single-line hide-details="auto"
                                        class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Contact Number</legend>
                                    <v-text-field v-model="form.contact_number" label="e.g. +8801XXXXXXXXX" solo
                                        single-line hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Nominee Email (Optional)</legend>
                                    <v-text-field v-model="form.nominee_email" label="example@mail.com" solo single-line
                                        hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Nominee ID Card (Optional)</legend>
                                    <v-text-field v-model="form.nominee_id_card" label="NID / Passport / Other" solo
                                        single-line hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <fieldset>
                                    <legend>Nominee Address (Optional)</legend>
                                    <v-text-field v-model="form.nominee_address" label="Full address" solo single-line
                                        hide-details="auto" class="custom-select" />
                                </fieldset>
                            </v-col>


                            <v-col cols="12" sm="12" md="12" class="d-flex">
                                <v-btn @click.prevent="submit" tile elevation="0"
                                    class="text-capitalize btn-account mr-2" color="greenMain" :loading="loading"
                                    :disabled="loading">
                                    {{ isEdit ? "Update" : "Save" }}
                                </v-btn>

                                <v-btn @click.prevent="resetForm" tile elevation="0" class="text-capitalize btn-account"
                                    color="warning" :disabled="loading">
                                    Reset
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-col>

            <!-- RIGHT: TABLE -->
            <v-col xl="7" lg="7" md="12" sm="12" cols="12">
                <v-sheet class="transactionTable pb-3" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                    <!-- <div class="title-bar">
                        <div>
                            <v-icon dense color="#5F7692">mdi-account-multiple-check</v-icon>
                            <span class="ml-2">My Nominees</span>
                        </div>

                        <v-spacer></v-spacer>

                        <v-text-field v-model="search" dense solo hide-details placeholder="Search"
                            prepend-inner-icon="mdi-magnify" style="max-width: 260px" class="mr-2" />
                    </div> -->

                    <div class="title-bar">
                        <div>
                            <v-icon dense color="#5F7692">mdi-account-multiple-check</v-icon>
                            <span class="ml-2">My Nominees</span>
                        </div>
                        <v-spacer></v-spacer>
                    </div>


                    <v-data-table :headers="headers" :items="nominees" :search="search" hide-default-footer>
                        <!-- NO DATA UI -->
                        <template v-slot:no-data>
                            <v-container fluid class="text-center">
                                <v-img src="/no-data.png" max-width="100" class="mx-auto mb-4"></v-img>
                                <p>No data available</p>
                            </v-container>
                        </template>

                        <!-- RELATIONSHIP -->
                        <template v-slot:item.relationship="{ item }">
                            {{
                                item.relationship === "others"
                                    ? (item.relationship_other || "Others")
                                    : capitalize(item.relationship)
                            }}
                        </template>

                        <!-- ALLOCATION -->
                        <template v-slot:item.allocation_percentage="{ item }">
                            {{ Number(item.allocation_percentage || 0).toFixed(2) }}%
                        </template>

                        <!-- ACTIONS -->
                        <template v-slot:item.actions="{ item }">
                            <div class="d-flex align-center justify-center">
                                <v-icon small class="mr-3" color="#039de9" @click="openDetails(item)">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon small color="#039de9" @click="editItem(item)">
                                    mdi-pencil-outline
                                </v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>

        </v-row>

        <!-- DETAILS MODAL -->
        <v-dialog v-model="detailsDialog" max-width="650">
            <v-card :color="$vuetify.theme.dark ? '#131c29' : '#FFFFFF'">
                <v-card-title class="d-flex justify-space-between align-center">
                    <span>Nominee Details</span>
                    <v-icon @click="detailsDialog = false">mdi-close</v-icon>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text v-if="selected">
                    <v-row class="mt-2" dense>
                        <v-col cols="12" md="6">
                            <p><b>Name:</b> {{ selected.nominee_name }}</p>
                            <p>
                                <b>Relationship:</b>
                                {{ selected.relationship === 'others'
                                    ? (selected.relationship_other || 'Others')
                                    : capitalize(selected.relationship) }}
                            </p>
                            <p><b>Contact:</b> {{ selected.contact_number }}</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <p><b>Email:</b> {{ selected.nominee_email || '-' }}</p>
                            <p><b>ID Card:</b> {{ selected.nominee_id_card || '-' }}</p>
                            <p><b>Client Email:</b> {{ selected.client_account_email || '-' }}</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <p class="mb-1"><b>Address:</b> {{ selected.nominee_address || '-' }}</p>
                        </v-col>

                        <v-col cols="12" md="6">
                            <p><b>Allocation:</b> {{ selected.allocation_percentage }}%</p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { NOMINEE__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
    data() {
        return {
            loading: false,
            search: "",
            isEdit: false,
            editId: null,

            detailsDialog: false,
            selected: null,

            form: {
                nominee_name: "",
                relationship: "",
                relationship_other: "",
                allocation_percentage: "",
                contact_number: "",
                nominee_email: "",
                nominee_id_card: "",
                nominee_address: "",
            },

            relationshipItems: [
                { text: "Wife", value: "wife" },
                { text: "Brother", value: "brother" },
                { text: "Daughter", value: "daughter" },
                { text: "Son", value: "son" },
                { text: "Father", value: "father" },
                { text: "Mother", value: "mother" },
                { text: "Others", value: "others" },
            ],

            headers: [
                { text: "Name", value: "nominee_name" },
                { text: "Relationship", value: "relationship" },
                { text: "Allocation (%)", value: "allocation_percentage" },
                { text: "Contact", value: "contact_number" },
                { text: "Email", value: "nominee_email" },
                { text: "ID Card", value: "nominee_id_card" },
                { text: "Actions", value: "actions", sortable: false, align: "center" },
            ],
        };
    },

    computed: {
        ...mapState("nominee", ["nominees"]),
    },

    methods: {
        ...mapActions("nominee", [
            NOMINEE__ACTIONS.FETCH_NOMINEES,
            NOMINEE__ACTIONS.CREATE_NOMINEE,
            NOMINEE__ACTIONS.UPDATE_NOMINEE,
            NOMINEE__ACTIONS.SHOW_NOMINEE,
        ]),

        capitalize(s) {
            if (!s) return "";
            return s.charAt(0).toUpperCase() + s.slice(1);
        },

        validate() {
            if (!this.form.nominee_name.trim()) return "Nominee name is required";
            if (!this.form.relationship) return "Relationship is required";
            if (this.form.relationship === "others" && !this.form.relationship_other.trim()) {
                return "Relationship (others) is required";
            }
            if (!this.form.contact_number.trim()) return "Contact number is required";

            const alloc = parseFloat(this.form.allocation_percentage);
            if (!Number.isFinite(alloc)) return "Allocation percentage is required";
            if (alloc <= 0 || alloc > 100) return "Allocation must be > 0 and <= 100";

            return null;
        },

        async submit() {
            const err = this.validate();
            if (err) return toast.error(err);

            try {
                this.loading = true;

                const payload = {
                    nominee_name: this.form.nominee_name,
                    relationship: this.form.relationship,
                    relationship_other: this.form.relationship === "others" ? this.form.relationship_other : null,
                    contact_number: this.form.contact_number,
                    nominee_email: this.form.nominee_email || null,
                    nominee_id_card: this.form.nominee_id_card || null,
                    nominee_address: this.form.nominee_address || null,
                    allocation_percentage: this.form.allocation_percentage,
                };

                let ok = false;

                if (this.isEdit && this.editId) {
                    ok = await this[NOMINEE__ACTIONS.UPDATE_NOMINEE]({ id: this.editId, payload });
                } else {
                    ok = await this[NOMINEE__ACTIONS.CREATE_NOMINEE](payload);
                }

                if (ok) this.resetForm();
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.isEdit = false;
            this.editId = null;
            this.form = {
                nominee_name: "",
                relationship: "",
                relationship_other: "",
                contact_number: "",
                nominee_email: "",
                nominee_id_card: "",
                nominee_address: "",
                allocation_percentage: "",
            };
        },

        openDetails(item) {
            this.selected = item;
            this.detailsDialog = true;
        },

        editItem(item) {
            this.isEdit = true;
            this.editId = item.id;

            this.form.nominee_name = item.nominee_name || "";
            this.form.relationship = item.relationship || "";
            this.form.relationship_other = item.relationship_other || "";
            this.form.contact_number = item.contact_number || "";
            this.form.nominee_email = item.nominee_email || "";
            this.form.nominee_id_card = item.nominee_id_card || "";
            this.form.nominee_address = item.nominee_address || "";
            this.form.allocation_percentage = item.allocation_percentage || "";
        },
    },

    async created() {
        await this[NOMINEE__ACTIONS.FETCH_NOMINEES]();
    },
};
</script>

<style>
/* keep your existing system classes; only minimal safe styles */
</style>
